function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateRange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.828,
    viewBox: "0 0 18 16.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5204"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5037"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5036"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3381",
    d: "M120.158-200.392a.853.853 0 0 0-.854.854v3.113a.853.853 0 0 0 .854.854.853.853 0 0 0 .854-.854v-3.113a.853.853 0 0 0-.854-.854z",
    transform: "translate(-114.395 200.392)",
    style: {
      fill: "#3e3f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3382",
    d: "M126.209-200.392a.853.853 0 0 0-.854.854v3.113a.853.853 0 0 0 .854.854.853.853 0 0 0 .854-.854v-3.113a.853.853 0 0 0-.854-.854z",
    transform: "translate(-114.427 200.392)",
    style: {
      fill: "#3e3f4c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3383",
    d: "M116.369-198.663h9.582v1.859h-9.582a.956.956 0 0 0-.952.959v9.715a.956.956 0 0 0 .952.959h12.407a.956.956 0 0 0 .952-.959v-9.715a.956.956 0 0 0-.952-.959.926.926 0 0 1-.922-.93.926.926 0 0 1 .922-.93 2.807 2.807 0 0 1 2.8 2.818v9.715a2.807 2.807 0 0 1-2.8 2.818h-12.407a2.807 2.807 0 0 1-2.8-2.818v-9.715a2.807 2.807 0 0 1 2.8-2.817z",
    transform: "translate(-113.572 200.139)",
    style: {
      fill: "#3e3f4c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5668",
    transform: "translate(1.707 6.51)",
    style: {
      fill: "#3e3f4c"
    },
    d: "M0 0h15.439v1.963H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRange);
export default __webpack_public_path__ + "static/media/dateRange.7d9f2c14.svg";
export { ForwardRef as ReactComponent };